import { filter, keyBy, map, find, reduce } from 'lodash';
import { ADD_ALL_ORGANIZATIONS, DELETE_ORGANIZATION, ADD_ORGANIZATION, UPDATE_ORGANIZATION,
  VIEW_ORGANIZATION, ADD_ALL_PI_USERS, VIEW_PI_USER, VIEW_PI_USER_ORGANIZATIONS, UNASSIGN_PI_USER_ORGANIZATION,
  ADD_TRUVOICE_CLIENTS, ADD_ALL_ADMIN_USERS,
  ADD_ADMIN_NEWS, DELETE_ADMIN_NEWS, LOAD_ADMIN_NEWS, EDIT_ADMIN_NEWS,
  ADD_DOMAIN_AUTHORIZATIONS, FETCH_TRUSALES_STATS } from './AdminActions';
import { VIEW_ORGANIZATION_USERS, DELETE_ORGANIZATION_USER,
  ADD_ORGANIZATION_USER, UPDATE_ORGANIZATION_USER, UPDATE_ORGANIZATION_USERS, SYNC_ORGANIZATION, REQUEST_SYNC_ORGANIZATION,
  END_REQUEST_SYNC_ORGANIZATION } from '../Setup/SetupActions';


// Initial State
const initialState = {
  organizations: {
    items: [],
    meta: {},
  },
  viewOrganization: {
    organization: {},
    users: {
      items: [],
      meta: {},
    },
  },
  piUsers: {
    items: [],
    meta: {},
  },
  adminUsers: {
    items: [],
    meta: {},
  },
  viewPIUser: {
    user: {},
    organizations: {
      items: [],
      meta: {},
    },
  },
  truVoiceClients: {
    status: null,
    errors: null,
    clients: {},
  },
  news: {
    status: null,
    errors: null,
    news: [],
  },
  viewNews: null,
  editedNews: null,
  tvDomains: {

  }, // indexed by org id
  tsStats: null
};

const AdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ALL_ORGANIZATIONS:
      return { ...state, organizations: action.organizations };
    case DELETE_ORGANIZATION: {
      const { organizations } = state;
      const items = filter(organizations.items, item => item._id !== action.id);
      return { ...state, organizations: { ...organizations, items } };
    }
    case DELETE_ORGANIZATION_USER: {
      const { viewOrganization, piUsers } = state;
      const items = filter(viewOrganization.users.items, item => item._id !== action.id);
      const piItems = filter(piUsers.items, item => item._id !== action.id);
      return { ...state, piItems: { ...piItems, items: piItems }, viewOrganization: { ...viewOrganization, users: { ...viewOrganization.users, items } } };
    }
    case VIEW_ORGANIZATION: {
      const { viewOrganization } = state;
      return { ...state, viewOrganization: { ...viewOrganization, organization: action.organization } };
    }
    case SYNC_ORGANIZATION:
    case UPDATE_ORGANIZATION: {
      const { organizations } = state;
      const items = organizations.items.map((item) => {
        if (item._id === action.organization._id) {
          return { ...item, ...action.organization };
        }
        return item;
      });
      return { ...state, organizations: { ...organizations, items } };
    }
    case REQUEST_SYNC_ORGANIZATION: {
      const { organizations } = state;
      const items = organizations.items.map((item) => {
        if (item.organization_id === action.id) {
          return { ...item, syncing: true };
        }
        return item;
      });
      return { ...state, organizations: { ...organizations, items } };
    }
    case END_REQUEST_SYNC_ORGANIZATION: {
      const { organizations } = state;
      const items = organizations.items.map((item) => {
        if (item.organization_id === action.id) {
          return { ...item, syncing: false };
        }
        return item;
      });
      return { ...state, organizations: { ...organizations, items } };
    }
    case ADD_ORGANIZATION: {
      const { organizations } = state;
      const items = organizations.items.concat(action.organization);
      return { ...state, organizations: { ...organizations, items } };
    }
    case VIEW_ORGANIZATION_USERS: {
      return { ...state, viewOrganization: { ...state.viewOrganization, users: action.users } };
    }
    case ADD_ORGANIZATION_USER: {
      const { viewOrganization } = state;
      const items = action.user.organization__id === viewOrganization._id ?
        viewOrganization.users.items.concat({ ...action.user }) : viewOrganization.users.items;
      return { ...state, viewOrganization: { ...viewOrganization, users: { ...viewOrganization.users, items } } };
    }
    case UPDATE_ORGANIZATION_USER: {
      const {
        viewOrganization, piUsers, viewPIUser, adminUsers,
      } = state;
      const items = viewOrganization.users.items.map((item) => {
        if (item._id === action.user._id) {
          return { ...item, ...action.user };
        }
        return item;
      });
      const piItems = piUsers.items.map((item) => {
        if (item._id === action.user._id) {
          return { ...item, ...action.user };
        }
        return item;
      });
      const adminItems = adminUsers.items.map((item) => {
        if (item._id === action.user._id) {
          return { ...item, ...action.user };
        }
        return item;
      });
      const updatedPIUser = viewPIUser.user._id === action.user._id ? { ...viewPIUser.user, ...action.user } : viewPIUser.user;
      return {
        ...state,
        viewPIUser: { ...viewPIUser, user: updatedPIUser },
        piUsers: { ...piUsers, items: piItems },
        adminUsers: { ...adminUsers, items: adminItems },
        viewOrganization: { ...viewOrganization, users: { ...viewOrganization.users, items } },
      };
    }
    case UPDATE_ORGANIZATION_USERS: {
      const {
        viewOrganization, piUsers, adminUsers,
      } = state;
      const indexed = keyBy(action.users, '_id');

      const items = viewOrganization.users.items.map((item) => {
        if (indexed[item._id]) {
          return { ...item, ...indexed[item._id] };
        }
        return item;
      });
      const piItems = piUsers.items.map((item) => {
        if (indexed[item._id]) {
          return { ...item, ...indexed[item._id] };
        }
        return item;
      });
      const adminItems = adminUsers.items.map((item) => {
        if (indexed[item._id]) {
          return { ...item, ...indexed[item._id] };
        }
        return item;
      });

      return {
        ...state,
        piUsers: { ...piUsers, items: piItems },
        adminUsers: { ...adminUsers, items: adminItems },
        viewOrganization: { ...viewOrganization, users: { ...viewOrganization.users, items } },
      };
    }
    
    case ADD_ALL_PI_USERS: {
      return { ...state, piUsers: action.users };
    }
    case ADD_ALL_ADMIN_USERS: {
      return { ...state, adminUsers: action.users };
    }
    case VIEW_PI_USER: {
      return { ...state, viewPIUser: { ...state.viewPIUser, user: action.user } };
    }
    case VIEW_PI_USER_ORGANIZATIONS: {
      return { ...state, viewPIUser: { ...state.viewPIUser, organizations: action.organizations } };
    }
    case UNASSIGN_PI_USER_ORGANIZATION: {
      const { viewPIUser } = state;
      const items = filter(viewPIUser.organizations.items, item => item._id !== action.organizationId);
      return { ...state, viewPIUser: { ...viewPIUser, organizations: { ...viewPIUser.organizations, items } } };
    }
    case ADD_TRUVOICE_CLIENTS: {
      return { ...state, truVoiceClients: { clients: keyBy(action.clients, 'client_id'), status: action.status, errors: action.errors } };
    }
    case ADD_ADMIN_NEWS: {
      const currentView = state.editedNews;
      const newItems = map(action.news, (item) => {
        const n = { ...item };
        n.$isUpdated = currentView && currentView._id === n._id;
        return n;
      });
      return { ...state, news: { news: newItems, status: action.status, errors: action.errors } };
    }
    case DELETE_ADMIN_NEWS: {
      const { news } = state;
      const items = news.news;
      const newItems = filter(items, item => (item._id !== action.id));

      return { ...state, news: { ...news, news: newItems } };
    }
    case LOAD_ADMIN_NEWS: {
      return { ...state, viewNews: action.news };
    }
    case EDIT_ADMIN_NEWS: {
      return { ...state, editedNews: action.news };
    }
    case ADD_DOMAIN_AUTHORIZATIONS: {
      const { id, status, clients, errors } = action;
      let hasSetup = false;
      const hasDomainAuthorized = reduce(clients, (items, client) => {
        // at least 1 domain authorized
        const d = find(client.domains, { authorized: true });
        if (client.domains && client.domains.length > 0) {
          hasSetup = true;
        }
        return items || (d !== undefined && d !== null);
      }, false);
      return { ...state, tvDomains: { ...state.tvDomains, [id]: { status, clients, errors, hasDomainAuthorized, hasSetup } } };
    }
    case FETCH_TRUSALES_STATS: {
      const { tsStats } = action;
      return { ...state, tsStats };
    }
    default:
      return state;
  }
};

/* Selectors */
export const getAllOrganizations = state => state.admin.organizations;
export const getViewOrganization = state => state.admin.viewOrganization.organization;
export const getViewOrganizationUsers = state => state.admin.viewOrganization.users;
export const getPIUsers = state => state.admin.piUsers;
export const getAdminUsers = state => state.admin.adminUsers;
export const getViewPIUser = state => state.admin.viewPIUser.user;
export const getViewPIUserOrganizations = state => state.admin.viewPIUser.organizations;
export const getTruVoiceClients = state => state.admin.truVoiceClients.clients;
export const getTruVoiceClientsLoading = state => state.admin.truVoiceClients.status === 'loading';
export const getTruVoiceClientsLoaded = state => state.admin.truVoiceClients.status === 'loaded';
export const getTruVoiceClientsHasErrors = state => state.admin.truVoiceClients.status === 'error';
export const getTruVoiceClientsErrors = state => (state.admin.truVoiceClients.status === 'error' ? state.admin.truVoiceClients.errors : null);
export const getNews = state => state.admin.news.news;
export const getNewsLoading = state => state.admin.news.status === 'loading';
export const getNewsLoaded = state => state.admin.news.status === 'loaded';
export const getNewsHasErrors = state => state.admin.news.status === 'error';
export const getNewsErrors = state => (state.admin.news.status === 'error' ? state.admin.news.errors : null);
export const getViewNews = state => state.admin.viewNews;
export const getTVDomains = (state, id) => state.admin.tvDomains?.[id] || {};

// Export Reducer
export default AdminReducer;
